import {HttpErrorResponse,HttpHeaders,HttpResponse} from '@angular/common/http';
import {Component,OnDestroy,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {JhiAlertService,JhiEventManager,JhiParseLinks} from 'ng-jhipster';
import {BsModalService,ModalDirective} from 'ngx-bootstrap';
import {Subscription} from 'rxjs';
import {Principal} from 'src/app/core';
import {ITEMS_PER_PAGE} from 'src/app/shared/constants/pagination.constants';
import {IClauseExtensionMySuffix} from 'src/app/shared/model/clause-extension-my-suffix.model';
import {IScopeMySuffix} from 'src/app/shared/model/scope-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {RoleUtil} from 'src/app/shared/util/role-util';
import {IPolicyMySuffix} from './../../shared/model/policy-my-suffix.model';
import {ClauseExtensionMySuffixService} from './clause-extension-my-suffix.service';

import { debounce } from "lodash";
import { CommonUtils } from 'src/app/shared/util/common-utils';


declare let $: any;


@Component({
    selector: 'jhi-clause-extension-my-suffix',
    templateUrl: './clause-extension-my-suffix.component.html'
})
export class ClauseExtensionMySuffixComponent implements OnInit,OnDestroy {
    @ViewChild('policyModal') policyModal: ModalDirective;

    currentAccount: any;
    clauseExtensions: IClauseExtensionMySuffix[];
    error: any;
    success: any;
    eventSubscriber: Subscription;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;
    searchText: string;
    flag: boolean;
    isShowPastHistory: boolean;
    isShowFutureHistory: boolean;
    ClauseExtId: number;
    modalTitle: string = 'Confirm operation';
    modalContent: string;
    status: string = '';
    showActiveModel: boolean = false;

    policyData: IPolicyMySuffix[]=[];

    public readonly RoleUtil = RoleUtil;

    constructor(
        private clauseExtensionService: ClauseExtensionMySuffixService,
        private parseLinks: JhiParseLinks,
        private jhiAlertService: JhiAlertService,
        public principal: Principal,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private eventManager: JhiEventManager,
        private languageChangeService: LanguageChangeService,
        private modalService:BsModalService
    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data.pagingParams.page;
            this.previousPage = data.pagingParams.page;
            this.reverse = data.pagingParams.ascending;
            this.predicate = data.pagingParams.predicate;
            // if(this.itemsPerPage == 25 && this.page >1){
            //     this.page = 1;
            //     this.previousPage = 1;
            // }
        });
                this.languageChangeService.refreshLanguage();
        this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            if (paramMap.get('size')) {
                this.itemsPerPage = paramMap.get('size')
            }
            const refresh = paramMap.get('refresh');
            if (refresh) {
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
    }

    loadAll() {
        this.searchText='';
        this.clauseExtensionService
            .query({
                page: this.page - 1,
                size: this.itemsPerPage,
                sort: this.sort()
            })
            .subscribe(
                (res: HttpResponse<IClauseExtensionMySuffix[]>) => this.paginateClauseExtensions(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res.message)
            );
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        if (this.searchText) {
            this.searchItems();
            this.flag = true;
        } else {
            this.router.navigate(['/data-management/clause-extension'], {
                queryParams: {
                    page: this.page,
                    size: this.itemsPerPage,
                    sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                }
            });
            this.loadAll();
        }
    }

    clear() {
        this.page = 0;
        this.router.navigate([
            '/data-management/clause-extension',
            {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        ]);
        this.loadAll();
    }

    ngOnInit() {
        this.principal.setTitle("Clauses & Extensions");
        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.isShowFutureHistory = this.principal.isShowFutureHistory;
        this.loadAll();
        this.principal.identity().then(account => {
            this.currentAccount = account;
        });

        this.registerChangeInClauseExtensions();
    }

    ngOnDestroy() {
        if (this.eventSubscriber) 
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: IClauseExtensionMySuffix) {
        return item.id;
    }

    registerChangeInClauseExtensions() {
        this.eventSubscriber = this.eventManager.subscribe('clauseExtensionListModification', response => this.loadAll());
    }

    sort() {
        const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    }

    private paginateClauseExtensions(data: IClauseExtensionMySuffix[], headers: HttpHeaders) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
        this.queryCount = this.totalItems;
        this.clauseExtensions = data;
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    downloadFileForCE(body, fileName, fileContentType) {
        let blob = new Blob([body], {
            type: fileContentType
        });
        if (blob.size > 0) {
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } else {
            alert('File not found');
        }
    }

    downloadFile(fileId, fileName, fileContentType) {
        this.clauseExtensionService.downloadFileService(fileId);
        // .subscribe(
        //     (res: HttpResponse<any>) => this.downloadFileForCE(res, fileName, fileContentType),
        //     (res: HttpErrorResponse) => this.onError(res.message)
        // );
    }

    get authority() {
        return this.principal.userIdentity.authorities[0];
    }
    searchItems() {
        // if (this.searchText) {
        //     let pNo = 0;
        //      let size = this.itemsPerPage;
        //     if (this.flag == true) {
        //         pNo = this.page - 1;
        //         size = this.itemsPerPage;
        //         this.flag = false;
        //     }
        //     this.principal
        //         .searchQuery(this.searchText, 'clause-extensions/search', {
        //             page: pNo,
        //             size: size,
        //             sort: this.sort()
        //         })
        //         .subscribe(
        //             (res: HttpResponse<IClauseExtensionMySuffix[]>) => this.paginateClauseExtensions(res.body, res.headers),
        //             (res: HttpErrorResponse) => this.onError(res.message)
        //         );
        // } else {
        //     this.loadAll();
        // }
        this.searchUsingDebounce();
    }

    // history
    parentHistoryToggle = false;
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;
    
    parentFutureHistoryToggle = false;
    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
        this.parentFutureHistoryToggle = $event;
    }

    viewFutureHistory(Obj) {
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Clause Extensions (' + Obj.name + ') Future Records';
        this.historyType = "CLAUSE_EXTENSION_AUDIT";
        this.historyId = Obj.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');
    }

    viewHistory(Obj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Clause Extensions (' + Obj.name + ') History';
        this.historyType = "CLAUSE_EXTENSION_AUDIT";
        this.historyId = Obj.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');
    }
    onChange(value){
        this.page = 0;
        this.itemsPerPage=value
        this.loadAll();
    }
    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            this.parentFutureHistoryToggle = false;
        }
    }


    openPolicyInfoModel(id) {
        this.policyData=[];
        let clauseExtAr: IClauseExtensionMySuffix[]=this.clauseExtensions.filter(c => c.id==id);
        let clauseExt=clauseExtAr[0];
        this.policyData=clauseExt.policies;
        this.policyModal.show();
    }

    hidePolicyModal() {
        this.policyModal.hide();
    }

    openScopePage(scope: IScopeMySuffix,policy: IPolicyMySuffix) {
        localStorage.setItem('policyId',JSON.stringify(policy.id));
        let url;
        if(policy.editPermission) {
             url = this.router.serializeUrl(this.router.createUrlTree(['/scope-my-suffix',scope.id,'view']))
        } else {
             url = this.router.serializeUrl(this.router.createUrlTree(['/scope-my-suffix/open-policy-scope-my-suffix', scope.id, 'view' ]))
        }
        window.open(url,'_blank');
    }

    openActivateModal(status, ClauseExtId) {
        this.showActiveModel = true;
        this.ClauseExtId = ClauseExtId;
        if (status == 'ACTIVATE') {
            this.modalContent = 'Are you sure you want to activate this  Clause/Extensions?'
            this.status = 'ACTIVE';
        } else {
            this.modalContent = 'Are you sure you want to In-activate this Clause/Extensions?'
            this.status = 'IN_ACTIVE'
        }
    }

    changeClauseExtStatus() {
        if (this.ClauseExtId) {
            this.clauseExtensionService.delete(this.ClauseExtId).subscribe(response => {
                if (this.status == 'ACTIVE') {
                    this.jhiAlertService.success('The clause/extensions has been activated successfully')
                } else {
                    this.jhiAlertService.success('The clause/extensions has been de-activated successfully')
                }
                this.loadAll();
            });
        }
    }

    closeActiveModels(e: boolean) {
        this.showActiveModel = e;
    }

    searchUsingDebounce = debounce(params => {
        if (this.searchText) {
            let pNo = 0;
            let size = this.itemsPerPage;
            if (CommonUtils.isNotNil(this.flag) && CommonUtils.isTrue(this.flag)) {
                pNo = this.page - 1;
                size = this.itemsPerPage;
                this.flag = false;
            } else {
                this.previousPage = this.page = 1;
            }
            this.principal
                .searchQuery(this.searchText, 'clause-extensions/search', {
                    page: pNo,
                    size: size,
                    sort: this.sort()
                })
                .subscribe(
                    (res: HttpResponse<IClauseExtensionMySuffix[]>) => this.paginateClauseExtensions(res.body, res.headers),
                    (res: HttpErrorResponse) => this.onError(res.message)
                );
        } else {
            this.loadAll();
        }
    }, 700);

}
